<div class="categoryTreeSpecifications">
    <div *ngFor="let item of list" class="rowCat">
        <div class="line"></div>
        <div class="cat">
            <div class="label">
              
              <span >
                <i class="fa" [ngClass]="expandedMap[item.id] ? 'fa-minus-square' : 'fa-plus-square'" (click)="getSubs(item)"
                style="cursor: pointer; margin-right: 8px;">
              </i>
              {{ item.fullName }}
              </span>
                <div class="actions">
                  <div class="list_opcion">
                    <i class="fa fa-download" (click)="onExport ? onExport(item.id) : viewSpecs(item.id); $event.stopPropagation()"
                      style="cursor: pointer; margin-left: 10px;" title="Descargar">
                    </i>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="expandedMap[item.id] && level < 3">
                <app-category-tree-specifications
                  [list]="childrenMap[item.id]"
                  [level]="level + 1"
                  (addCategoryEvent)="addCategory($event)"
                  (editCategoryEvent)="editCategory($event)"
                  (deleteCategoryEvent)="deleteCategory($event)"
                  [onExport]="onExport"
                  >
                </app-category-tree-specifications>
              </ng-container>
        </div>
    </div>
</div>